import React from 'react';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
import { Modal, Button } from '@scale/scaleui';
import { Text } from 'react-scale/components/design-system/Typography';

const SubmitSubstageModal = ({
  substageInstanceId,
  open,
  setOpen,
}: {
  substageInstanceId: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
}) => {
  const handleSubmitSubstageInstance = async () => {
    try {
      const submitSubstageInstanceTemporalId = await apiFetch(
        null,
        `corp-api/sfu_task_tracker/submit_substage_instance`,
        {
          method: 'POST',
          body: { substageInstanceId },
        },
      );
      alert(`Substage submitted! Temporal ID: ${submitSubstageInstanceTemporalId}`);
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    }
  };

  const handleSubmit = () => {
    handleSubmitSubstageInstance();
    setOpen(false);
  };

  return (
    <div className="scaleui scale-tailwind">
      <Modal
        innerClassName="max-w-sm"
        onClose={() => {
          setOpen(false);
        }}
        theme="scale-theme"
        title={`Submit Substage Instance`}
        open={open}
        actions={
          <div className="flex items-center gap-2 justify-end">
            <Button onClick={handleSubmit}>Submit</Button>
          </div>
        }
      >
        <Text>
          Are you sure you want to submit <strong>{substageInstanceId}</strong>?
        </Text>
      </Modal>
    </div>
  );
};
export default SubmitSubstageModal;
